export default "__VITE_ASSET__NF6U00Cm__"